"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledViewForm = exports.StyledTitle = exports.TitleBar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PrimaryText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PrimaryText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var TitleBar = _styledComponents.default.div.withConfig({
  displayName: "AdressManualFormstyles__TitleBar",
  componentId: "sc-7eazfw-0"
})(["display:flex;flex-direction:row;justify-content:flex-end;align-items:baseline;"]);

exports.TitleBar = TitleBar;
var StyledTitle = (0, _styledComponents.default)(_PrimaryText.default).withConfig({
  displayName: "AdressManualFormstyles__StyledTitle",
  componentId: "sc-7eazfw-1"
})(["max-width:100%;font-weight:", ";flex:1 1 100%;"], function (props) {
  return props.theme.primaryMedium;
});
exports.StyledTitle = StyledTitle;

var StyledViewForm = _styledComponents.default.div.withConfig({
  displayName: "AdressManualFormstyles__StyledViewForm",
  componentId: "sc-7eazfw-2"
})([".c-address-manual-form-label{display:block;font-weight:", ";padding-bottom:.45rem;}.c-address-manual-form-read-only-wrapper{display:flex;flex-direction:row;width:100%;}.c-address-manual-form-view-text-rapper{width:100%;}.c-address-manual-form-view-text{padding:0 0 0 ", ";position:relative;}.c-address-manual-form-edit-button{margin:0 1rem;right:0;position:relative;}.c-address-manual-form-title-bar{width:100%;display:flex;flex-direction:row nowrap;justify-content:flex-end;}"], function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledViewForm = StyledViewForm;